<div class="search-no-results d-flex flex-column align-items-center text-center py-4">

  <!-- Astronaut Lottie illustration -->
  <div class="search-no-results__illustration mb-3">
    <div #lottieContainer class="search-no-results__lottie"></div>
  </div>

  <!-- Heading -->
  <h3 class="search-no-results__title text-base fw-600 mb-1">
    No Results for&nbsp;<span class="text-primary">"{{ query }}"</span>
  </h3>
  <p class="search-no-results__subtitle text-sm text-gray-dark mb-4">
    Check the spelling, broaden the term, or search full text.
  </p>

  <!-- Action buttons -->
  <div class="d-flex align-items-center gap-3 flex-wrap justify-content-center mb-4">
    <button
      type="button"
      class="btn btn-secondary d-flex align-items-center gap-2"
      (click)="requestArtefact.emit()"
    >
      <img src="images/Person-Info.svg" width="14" height="14" alt="" />
      Request Artefact
    </button>

    <button
      type="button"
      class="btn btn-bordered-black bg-white"
      (click)="fullTextSearch.emit()"
    >
      Full Text Search
    </button>
  </div>

  <!-- Ask Assistant -->
  @if (showAskAssistant && query) {
    <div class="search-no-results__ask-assistant w-100 text-start">
      <p class="text-xs text-gray fw-500 text-uppercase mb-2">Ask Assistant</p>
      <button
        type="button"
        class="search-no-results__ask-btn button-no-style d-flex align-items-center gap-2 text-primary fw-500 text-sm"
        (click)="askAssistant.emit(query)"
      >
        <img src="images/Sparkle.svg" width="14" height="14" alt="" />
        <span class="search-no-results__ask-text">Can you Tell me About {{ query }}&nbsp;?</span>
      </button>
    </div>
  }

</div>
